import { BetType } from "../types/common";
import BetTicket from "../services/betTicket";
import Member from "../services/member";
import {
  BetTicketInfoPayload,
  BetTicketInfoForDisplay,
  PlaceBetTicketPayload,
} from "../types/betTicket";
import { CONFIG } from "../config";
import {
  MIXED_PROVIDER_MESSAGE,
  normalizeProviderForComparison,
  resolveProvider,
  isSabaComboDisabled,
  SABA_COMBO_MESSAGE,
} from "../utils/providerQuery";
import { toast } from "react-toastify";

const betTicket = new BetTicket();
const member = new Member();

const mutation = {
  pinFavorite: (payload: {
    memberId: string;
    update: { id: string; name: string };
    type: "LEAGUE" | "TEAM";
  }) => {
    return member.pinFavorite(payload.memberId, payload.update, payload.type);
  },

  placeBetTicket: (payload: PlaceBetTicketPayload) => {
    return betTicket.placeBetTicket(payload);
  },

  updateBetTicketInfoPayload: async (
    payload: (BetTicketInfoForDisplay & BetTicketInfoPayload)[],
  ) => {
    if (CONFIG.ENV !== "production" || payload.length === 0) {
      return payload;
    }

    const hasDisabledSabaCombo = payload.some((item) => {
      return (
        item.type === "comboStep" &&
        isSabaComboDisabled(item.pvd, item.sportType)
      );
    });

    if (hasDisabledSabaCombo) {
      toast.error(SABA_COMBO_MESSAGE);
      throw new Error(SABA_COMBO_MESSAGE);
    }

    const normalizedPayload = payload.map((item) => {
      const resolvedProvider = resolveProvider(item.pvd, item.sportType);
      if (resolvedProvider === item.pvd) {
        return { ...item };
      }

      return { ...item, pvd: resolvedProvider };
    });
    const effectiveProviders = normalizedPayload.map((item) => {
      return normalizeProviderForComparison(item.pvd);
    });
    const uniqueProviders = new Set(effectiveProviders);

    if (uniqueProviders.size > 1) {
      toast.error(MIXED_PROVIDER_MESSAGE);
      throw new Error(MIXED_PROVIDER_MESSAGE);
    }

    return normalizedPayload;
  },

  updateCurrentTabIndex: async (currentIndex: number) => {
    return currentIndex;
  },

  updateProvider: async (provider: string) => {
    return provider;
  },

  updateOddsType: async (oddsType: number) => {
    return oddsType;
  },

  updateBetType: async (betType: BetType) => {
    return betType;
  },

  updateIsBetSlipToggle: async (isBetSlipToggle: boolean) => {
    return isBetSlipToggle;
  },

  updateIsMenuFooterToggle: async (isMenuFooterToggle: boolean) => {
    return isMenuFooterToggle;
  },

  updateIsLanguageToggle: async (isLanguageToggle: boolean) => {
    return isLanguageToggle;
  },

  undateIsOddsTypeToggle: async (isOddsTypeToggle: boolean) => {
    return isOddsTypeToggle;
  },

  updateIsForceScreen: async (isForceScreen: boolean) => {
    return isForceScreen;
  },
};

export default mutation;
